import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import WalletIcon from 'src/assets/icons/WalletIcon';
import { CircularProgress } from '@mui/material';
import useApi from 'src/hooks/useApi';
import services from 'src/api/service';
import { useRankingDashboardContext } from 'src/contexts/RankingDashboardContext';
import { kpiFormatter } from 'src/views/pages/targetting/formatter';

export default function RankingWallet() {
    const history = useHistory();
    const doGetWalletBalance = useApi(services.postService);
    const [walletBalance, setWalletBalance] = useState(0);
    const { walletRefreshTrigger, setWalletBalance: setWalletBalanceInContext } = useRankingDashboardContext();

    const fetchWalletBalance = () => {
        doGetWalletBalance.request({
            url: '/ranking/get-wallet-details',
            payload: {}
        });
    };

    useEffect(() => {
        fetchWalletBalance();
    }, []);

    useEffect(() => {
        if (walletRefreshTrigger > 0) {
            fetchWalletBalance();
        }
    }, [walletRefreshTrigger]);

    useEffect(() => {
        const { data, loading } = doGetWalletBalance;
        if (!loading && data && data?.success === true && data?.data) {
            const balance = data?.data?.walletBalance || 0;
            setWalletBalance(balance);
            setWalletBalanceInContext(balance);
        }
    }, [doGetWalletBalance.loading, setWalletBalanceInContext]);

    const handleClick = () => {
        history.push('/amazon-ranking-billing-payments?view=brand&type=recharge');
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleClick();
        }
    };

    return (
        <section
            className="global-filter f-14 f-w-600 cursor-pointer"
            style={{border:'1px solid #5932EA', font:'Open Sans'}}
            onClick={handleClick}
            onKeyDown={handleKeyDown}
            role="button"
            tabIndex={0}
        >
            <WalletIcon />
            <span>Balance:</span>
           {doGetWalletBalance?.loading ? <CircularProgress size={18} sx={{
                color: '#5932EA',
            }} />
            : <span>{kpiFormatter(walletBalance, 'wallet_decimal_currency')}</span>}
        </section>
    )
}
